<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-0">
          <v-card-text>
            <v-row>
              <v-col cols="12" v-html="text"></v-col>
              <v-col cols="12" class="pt-3">
                <el-byla
                  v-for="byla in bylos"
                  :key="byla.byl_id"
                  :byla="byla"
                  color="primary"
                  with-name
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="submit()">
          Uždaryti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalArchyvasBylos',
  props: {
    title: String,
    text: String,
    bylos: Array,
    value: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return 'Submit'
    },
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.$emit('confirm' + this.modalAction)
      this.closeModal()
    },
    cancel() {
      this.submit()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
